var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5137 3.33631C21.7833 3.01897 20.9363 3.15664 20.3542 3.69331L17.833 6.02664V4.33264C17.833 2.40297 16.2638 0.832642 14.333 0.832642H3.83301C1.90334 0.832642 0.333008 2.40297 0.333008 4.33264V13.666C0.333008 15.5968 1.90334 17.166 3.83301 17.166H14.333C16.2638 17.166 17.833 15.5968 17.833 13.666V11.9731L20.3542 14.3053C20.7287 14.6518 21.2128 14.8326 21.7063 14.8326C21.9782 14.8326 22.2523 14.7778 22.5137 14.6635C23.2242 14.3531 23.6663 13.6893 23.6663 12.9321V5.06764C23.6663 4.31047 23.2242 3.64664 22.5137 3.33631Z",
    fill: "#7B819B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFile);
export default __webpack_public_path__ + "static/media/videoFile.6ed2087f4a667303fe136fb0a5163095.svg";
export { ForwardRef as ReactComponent };